var React = require('react');

function EasyToWorkWithInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"24.74","y":"12.88","width":"2.37","height":"9.15","key":0}),React.createElement("rect",{"x":"28.81","y":"17.46","width":"2.37","height":"4.57","key":1}),React.createElement("polygon",{"points":"32.93 30.64 25.01 30.64 22.86 28.53 22.86 19.89 20.49 19.89 20.49 29.52 24.04 33 35.29 33 35.29 17.46 32.93 17.46 32.93 30.64","key":2}),React.createElement("polygon",{"points":"32.94 7 7.06 7 4.71 7 4.71 9.35 4.71 25.83 4.71 28.18 7.06 28.18 17.92 28.18 17.92 25.83 7.06 25.83 7.06 9.35 32.94 9.35 32.94 14.89 35.29 14.89 35.29 9.35 35.29 7 32.94 7","key":3})]);
}

EasyToWorkWithInline.defaultProps = {"id":"Warstwa_1","viewBox":"0 0 40 40","width":"32","height":"32"};

module.exports = EasyToWorkWithInline;

EasyToWorkWithInline.default = EasyToWorkWithInline;
